import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BaseComponent } from '@max/shared/base-components/base.component';
import { finalize } from 'rxjs/operators';
import { CheckinService } from '../services/checkin.service';

export class TransactionTransferModalContext {
    constructor(public businessTransactionId: number, public businessUnitId: number, public businessUnitName: string) {}
}

@Component({
    selector: 'transaction-transfer-modal',
    templateUrl: './transaction-transfer-modal.html'
})
export class TransactionTransferModal extends BaseComponent {

    public businessUnitName: string;
    public transferringTransaction: boolean;

    constructor(
        public dialogRef: MatDialogRef<TransactionTransferModal>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: TransactionTransferModalContext,
        private checkinService: CheckinService,
    ) {
        super();
    }

    ngOnInit() {
        this.businessUnitName = this.data.businessUnitName;
    }

    confirm() {
        this.transferringTransaction = true;
        this.checkinService.transferTransaction([this.data.businessTransactionId], this.data.businessUnitId)
            .pipe(finalize(() => this.transferringTransaction = false))
            .subscribe(
                _ => this.dialogRef.close(true),
                e => this.handleValidationResult(e.error)
            );
    }

    cancel() {
        this.dialogRef.close(false);
    }
}
